import * as React from 'react'

export const ContactIcon = () => {
  return (
    <svg width='16' height='18' viewBox='0 0 16 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16 7.91479C16 11.8121 13.1529 15.0514 9.40415 15.7081L5.09432 18L5.09408 15.2912C2.11251 14.1407 0 11.2718 0 7.91479C0 3.54357 3.58172 0 8 0C12.4183 0 16 3.54357 16 7.91479ZM9.80575 13.277C8.45739 13.277 7.31031 12.4244 6.88518 11.2344H12.7263C12.3012 12.4244 11.1541 13.277 9.80575 13.277Z'
        fill='currentColor'
      />
    </svg>
  )
}
